export const hoursInWeek = 7 * 24
